Vue.component('productdetailConfigurable', {
    data() {
        return {
            configuratorOpen: false,
            configurator3dopen: false,
            isInitialConfiguratorLoaded: false,
            configuratorSettings: {
                container: document.getElementById('configurator__config'),
                url: '',
                articleCode: null,
                collection: null,
                code: null,
                width: null,
                height: null,
                ecotax: null,
                assemblyCost: null,
                showOptionSize: null
            },
            errorText: '',
            productBasePrice: null,
            productPrevPrice: null,
            productExtraPrice: null,
            currentSelection: [],
            configurator: null,
            selectionIndex: 1,
            groupNameIndex: 1,
            currentChoiceStep: 1,
            previousChoicesGroupName: '',
            productDetailSliders: [],
            erpOptions: [],
            showStepIndicator: false,
            first: true,
            isLoading: false,
            observerLoaded: false,
            initializedDraggable: false,
            emailSentSuccess: false,
            emailSentMessage: '',
            isEmailDisabled: false,
            arSlider: null,
            arModal: null,
            qrModal: null,
            showModelViewerDimensions: false,
            zoomButtonPressed: false,
            backgroundColor: ""

        };
    },
    props: ['colijnurl'],
  mounted() {
    this.configuratorSettings.url = this.configuratorSettings.container.getAttribute('data-url');
    this.configuratorSettings.width = this.configuratorSettings.container.getAttribute('data-width');
    this.configuratorSettings.height = this.configuratorSettings.container.getAttribute('data-height');
    this.configuratorSettings.articleCode = this.configuratorSettings.container.getAttribute('data-articlecode');
    this.configuratorSettings.collection = this.configuratorSettings.container.getAttribute('data-collection');
    this.configuratorSettings.code = this.configuratorSettings.container.getAttribute('data-code');
    this.configuratorSettings.ecotax = this.configuratorSettings.container.getAttribute('data-ecotax');
    this.configuratorSettings.assemblyCost = this.configuratorSettings.container.getAttribute('data-assemblycost');
    this.configuratorSettings.showOptionSize = parseInt(this.configuratorSettings.container.getAttribute('data-showoptionsize'), 10);
    this.productBasePrice = parseFloat(this.configuratorSettings.container.getAttribute('data-baseprice'));

    this.productPrevPrice = this.productBasePrice;

    // Load Configurator with deeplink
    this.checkHash();

      Vue.nextTick(() => {
          this.fetchMaterialGroups('', '');

          const m = document.querySelector('#dimensionsviewer');

          if (m) {

              m.addEventListener('progress', (event) => {
                  const progressBar = event.target.querySelector('.glb-progress-bar');
                  const updatingBar = event.target.querySelector('.glb-update-bar');
                  if (event.detail.totalProgress === 0) {
                      progressBar.style.display = 'block';
                      updatingBar.style.width = '0%';
                  } else {
                      updatingBar.style.width = `${event.detail.totalProgress * 100}%`;

                      if (event.detail.totalProgress === 1) {
                          setTimeout(() => {
                              progressBar.style.display = 'none';
                          }, 500);
                      }
                  }
              });

              m.addEventListener('load', (event) => {

                  //const m = event.target;

                  m.addEventListener('camera-change', (dimev2) => {

                      app.renderModelViewerSVG(m, true);

                  });

                  let h = m.getAttribute('data-h'); // size.y
                  let d = m.getAttribute('data-d'); // size.z
                  let w = m.getAttribute('data-w'); // size.x

                  app.setModelViewerHotspot(m, h, d, w);

                  app.renderModelViewerSVG(m, true);

                  m.resetTurntableRotation(0);
                  m.setAttribute("camera-orbit", "45deg 75deg 114%");

                  setTimeout(() => {
                      app.setModelViewerVisibility(m, m.querySelector('#dimlines'), true);
                      m.querySelectorAll('button').forEach((hotspot) => {
                          app.setModelViewerVisibility(m, hotspot, true);
                      });
                  }, 100);

                  const zoomOut = m.querySelector('#dimensionzoom-out');

                  zoomOut.addEventListener('click', (zoomevt) => {

                     if (document.body.style.overflow === "hidden") {

                        setTimeout(() => {
                            this.ModelViewerNormalScreen('dimensionsviewer', '#dimensionmodelviewerzoom');
                        }, 0);

                     } else {
                        setTimeout(() => {
                        this.ModelViewerFullScreen('dimensionsviewer', '#dimensionmodelviewerzoom', false);
                        }, 0);

                     }

                  });
              });


          }

          //------------------

          const mv = document.querySelector('#modelviewermodel');

          if (mv) {

              let h = mv.getAttribute('data-h'); // size.y
              let d = mv.getAttribute('data-d'); // size.z
              let w = mv.getAttribute('data-w'); // size.x

              this.backgroundColor = mv.getAttribute('data-backgroundcolor');

              mv.addEventListener('progress', (event) => {
                  const progressBar = event.target.querySelector('.glb-progress-bar');
                  const updatingBar = event.target.querySelector('.glb-update-bar');
                  if (event.detail.totalProgress === 0) {
                      progressBar.style.display = 'block';
                      updatingBar.style.width = '0%';
                  } else {
                      updatingBar.style.width = `${event.detail.totalProgress * 100}%`;

                      if (event.detail.totalProgress === 1) {
                          setTimeout(() => {
                              progressBar.style.display = 'none';
                          }, 500);
                      }
                  }
              });

              mv.addEventListener('load', (event) => {

                  const m2 = event.target;

                  m2.addEventListener('camera-change', (ev) => {

                      const mm = ev.target;

                      app.renderModelViewerSVG(mm, this.showModelViewerDimensions);

                      if (!this.zoomButtonPressed) {
                          mm.removeAttribute("auto-rotate");
                      } else {
                          setTimeout(() => {
                              this.zoomButtonPressed = false;
                          }, 100);
                      }
                  });

                  app.setModelViewerHotspot(m2, h, d, w);

                  app.renderModelViewerSVG(m2, this.showModelViewerDimensions);

              });

              const showDimensions = mv.querySelector('#show-dimensions');

              showDimensions.addEventListener('click', (event) => {

                  const modelViewer = event.target.closest('model-viewer');

                  this.showModelViewerDimensions = !this.showModelViewerDimensions;

                  if (this.showModelViewerDimensions) {
                      modelViewer.resetTurntableRotation(0);
                      modelViewer.setAttribute("camera-orbit", "45deg 75deg 114%");
                  }

                  setTimeout(() => {
                      app.setModelViewerVisibility(modelViewer, modelViewer.querySelector('#dimlines'), this.showModelViewerDimensions);
                      modelViewer.querySelectorAll('button').forEach((hotspot) => {
                          app.setModelViewerVisibility(modelViewer, hotspot, this.showModelViewerDimensions);
                      });
                  }, 100);

              });

              const zoomOut = mv.querySelector('#zoom-out');

              zoomOut.addEventListener('click', (event) => {

                  const modelViewer = event.target.closest('model-viewer');

                  if (document.body.style.overflow === "hidden") {

                      this.ModelViewerNormalScreen('modelviewer', '#modelviewerzoom');

                      modelViewer.removeAttribute("camera-controls");

                      modelViewer.resetTurntableRotation(0);
                      modelViewer.setAttribute("camera-orbit", "45deg 75deg 114%");
                      modelViewer.setAttribute("camera-target", "auto auto auto");
                      modelViewer.setAttribute("auto-rotate", "");

                      if (this.showModelViewerDimensions)
                      {
                          this.showModelViewerDimensions = false;

                          setTimeout(() => {
                              app.setModelViewerVisibility(modelViewer, modelViewer.querySelector('#dimlines'), this.showModelViewerDimensions);
                              modelViewer.querySelectorAll('button').forEach((hotspot) => {
                                  app.setModelViewerVisibility(modelViewer, hotspot, this.showModelViewerDimensions);
                              });
                          }, 100);
                      }

                      this.productDetailSliders[0].options.draggable = '>1';
                      this.productDetailSliders[0].updateDraggable();

                  } else {

                      this.ModelViewerFullScreen('modelviewer', '#modelviewerzoom', false);

                      modelViewer.setAttribute("camera-controls", "");

                      modelViewer.resetTurntableRotation(0);
                      modelViewer.setAttribute("camera-orbit", "45deg 75deg 114%");
                      modelViewer.setAttribute("camera-target", "auto auto auto");
                      modelViewer.setAttribute("auto-rotate", "");

                      this.productDetailSliders[0].options.draggable = false;
                      this.productDetailSliders[0].updateDraggable();

                  }

              });


          }
      });

      window.addEventListener('keyup', (keyevt) => {

          if (document.body.style.overflow === "hidden" && keyevt.key === "Escape") {

              this.ModelViewerNormalScreen('modelviewer', '#modelviewerzoom');

              this.ModelViewerNormalScreen('dimensionsviewer', '#dimensionmodelviewerzoom');
          }
      });

      window.addEventListener('resize', (resizeevt) => {

          if (document.body.style.overflow === "hidden") {

              this.ModelViewerFullScreen('modelviewer', '#modelviewerzoom', true);

              this.ModelViewerFullScreen('dimensionsviewer', '#dimensionmodelviewerzoom', true);
          }

      });
    /*
    // Set Initial State
    window.history.replaceState({ configurator: this.configuratorOpen }, document.title, window.location.pathname);

    // Load Configurator when user uses browser back
    window.onpopstate = (e) => {
        if (e.state !== null) {
            if (e.state.configurator != null) {
                this.toggleConfigurator(true);
            } else if (e.state.config3d != null) {
                this.toggleconfigurator3d(true);
            }
        }
    };*/
  },
  watch: {
    configuratorOpen(open) {
      if (open && !this.isInitialConfiguratorLoaded) {
        this.isInitialConfiguratorLoaded = true;
        // Replace Initial State
        //window.history.replaceState({ configurator: this.configuratorOpen }, 'deeplink', '#configurator');
        this.loadConfiguratorOptions();
      }
    },
    },
    computed: {
        filteredConfigurationList: function () {

            if (this.configurator.currentConfigurationList) {
                return this.configurator.currentConfigurationList.filter(function(f) {
                    return f.showConsumer && f.optionGroupName;
                });
            }
            return null;
        }
    },
    methods: {
        showMaterialPopup(description) {
            if (description && description.length > 0) {
                console.log(description)
            }
        },
        fetchMaterialGroups(filterColor, loadingMessage) {

            var url = window.location.href.replace(window.location.search, '');

            if (url.indexOf("#") !== -1) {
                url = url.substring(0, url.lastIndexOf("#"));
            }

            var materialGroupElement = document.querySelector('.productdetail__tabs__price-info__groups');

            if (materialGroupElement != null) {

                materialGroupElement.innerHTML = "<p class=\"feedback--success\">" + loadingMessage + "</p>";

                var code = materialGroupElement.getAttribute('data-code');

                const postUrl = `${url}?code=${code}&filterColor=${filterColor}`;

                fetch(postUrl,
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "text/html; charset=UTF-8",
                            "Accept-Language": document.documentElement.lang,
                            "X-Requested-With": "XMLHttpRequest"
                        },
                        credentials: 'same-origin',
                    })
                    .then(response => response.text())
                    .then((response) => {

                        if (response.length < 150) {
                            materialGroupElement.innerHTML = "<p class=\"feedback--error\">-----</p>";
                        } else {
                            materialGroupElement.innerHTML = response;
                        }
                        fAccordion();
                        fTooltip();

                    });
            }
        },

        sendArLogging(type, code) {

            fetch('/api/cart/arlog',
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': document.documentElement.lang,
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    credentials: 'same-origin',
                    body: JSON.stringify({
                        Type: type,
                        Code: code.replace('p-','')
                    })
                }).then((response) => {

                });
        },

        handleqr(event, code) {

            this.sendArLogging('QR', code);

            this.qrModal = new Modal(document.querySelector('.js-qr-modal'));

            this.qrModal.open();

            if (event) {
                event.preventDefault()
            }

            return false;
        },

        handleusdz(event, url, force, code) {

            if (force === 2 || (force === 0 && docCookies.getItem('arhelp') === null)) {
                this.arModal = new Modal(document.querySelector('.js-ar-modal'));

                this.arModal.open();

                this.arSlider.select(0, false, true);
                this.arSlider.resize();

                if (event) {
                    event.preventDefault()
                }

                return false;
            }

            if (this.arModal) {
                this.arModal.close();
            }

            this.sendArLogging('IPHONE', code);

            docCookies.setItem('arhelp', '1', Infinity, '/');

            return true;
        },

        handlearglb(event, url, force, enableVerticalPlacement, code) {

            if (force === 2 || (force === 0 && docCookies.getItem('arhelp') === null)) {
                this.arModal = new Modal(document.querySelector('.js-ar-modal'));

                this.arModal.open();

                this.arSlider.select(0, false, true);
                this.arSlider.resize();

                if (event) {
                    event.preventDefault()
                }

                return false;
            }

            if (this.arModal) {
                this.arModal.close();
            }

            this.sendArLogging('ANDROID', code);

            docCookies.setItem('arhelp', '1', Infinity, '/');

            var vp = '';
            if (enableVerticalPlacement) {
                vp = 'enable_vertical_placement=true&';
            }

            var arurl = 'intent://arvr.google.com/scene-viewer/1.0?' +
                vp +
                'file=' +
                url +
                '#Intent;scheme=https;package=com.google.android.googlequicksearchbox;action=android.intent.action.VIEW;end;';

            window.location.href = arurl;

            return true;
        },

        email(e) {
            e.preventDefault();

            if (e.target.elements.NarrowcastingEmail.value !== '') {

                this.isEmailDisabled = true;

                fetch('/api/articleconfigurator/email', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': document.documentElement.lang,
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    credentials: 'same-origin',
                    body: JSON.stringify({
                        Email: e.target.elements.NarrowcastingEmail.value,
                        Configurator: this.configurator,
                        ArticleName: e.target.elements.ArticleName.value,
                        ArticleCode: e.target.elements.ArticleCode.value,
                        Url: e.target.elements.EmailUrl.value
                    }),
                }).then(response => response.json()).then((registerResponse) => {

                    this.isEmailDisabled = false;

                    if (!registerResponse.emailSucceeded && registerResponse.errorMessage !== '' && !e.target.elements.NarrowcastingEmail.classList.contains('has-error')) {

                        this.emailSentMessage = registerResponse.errorMessage;

                        validate.showError(e.target.elements.NarrowcastingEmail, registerResponse.errorMessage);

                    } else if (registerResponse.emailSucceeded) {

                        e.target.elements.NarrowcastingEmail.value = '';

                        this.emailSentSuccess = true;
                        setTimeout(() => { this.emailSentSuccess = false; }, 2000);
                    }

                });

            }
        },

    spaceList (count) {
        return ("&nbsp;").repeat(count * 3);
    },

    toggleconfigurator3d(byPopState) {

        app.justAddedToCart = false;

        var footer = document.getElementsByClassName('footer');

        var iframe = document.getElementById('iframeWebGL');

        if (iframe != null) {

            if (!this.configurator3dopen) {
                window.scroll(0, 0);
            }

            this.configurator3dopen = !this.configurator3dopen;

            if (this.configurator3dopen) {

                app.showStickyHeader(false);

                if (footer != null && footer.length > 0) {
                    footer[0].style.display = "none";
                }

                var receipt = document.getElementById('roomplannerreceipt');
                if (receipt != null) {

                    iframe.style.display = "block";

                    receipt.style.display = "none";

                    var backdetailsbutton = document.getElementById('backdetailsbutton');
                    if (backdetailsbutton != null) {
                        backdetailsbutton.style.display = "inline-block";
                    }

                    var receiptbackbutton = document.getElementById('receiptbackbutton');
                    if (receiptbackbutton != null) {
                        receiptbackbutton.style.display = "none";
                    }

                    var receiptbutton = document.getElementById('receiptbutton');
                    if (receiptbutton != null) {
                        receiptbutton.style.display = "none";
                    }
                }

                document.body.classList.add('configurator-open');

                iframe.src = this.colijnurl;

                app.influxDbEvent("Show3dConfigurator");
            } else {
                app.showStickyHeader(true);

                if (footer != null && footer.length > 0) {
                    footer[0].style.display = "block";
                }

                document.body.classList.remove('configurator-open');
            }
            /*
            if (!byPopState) {
                if (this.configurator3dopen) {
                    window.history.pushState({ config3d: this.configurator3dopen }, 'deeplink', '#config3d');
                } else {
                    window.history.pushState({ config3d: this.configurator3dopen },
                        document.title,
                        window.location.pathname);

                }
            }*/
        }
    },

    toggleConfigurator(byPopState) {
        this.configuratorOpen = !this.configuratorOpen;

        var footer = document.getElementsByClassName('footer');

        if (this.configuratorOpen) {
            app.showStickyHeader(false);

            if (footer != null && footer.length > 0) {
                footer[0].style.display = "none";
            }

            document.body.classList.add('configurator-open');
        } else {
            app.showStickyHeader(true);

            if (footer != null && footer.length > 0) {
                footer[0].style.display = "block";
            }

            document.body.classList.remove('configurator-open');
        }
        /*
        if (!byPopState) {
        if (this.configuratorOpen) {
          window.history.pushState({ configurator: this.configuratorOpen }, 'deeplink', '#configurator');
        } else {
          window.history.pushState({ configurator: this.configuratorOpen }, document.title, window.location.pathname);
          
          Vue.nextTick(() => {
            this.redrawSliders();
          });
        }
      }*/
    },

    checkHash() {
        if (window.location.hash !== null) {
            if (window.location.hash.indexOf('configurator') > 0) {
                this.toggleConfigurator(false);
            } else if (window.location.hash.indexOf('config3d') > 0) {
                this.toggleconfigurator3d(false);
            }
        }
    },
    onSliderReady(slider) {
        if (slider.classList.contains('productdetail__slider__main')) {
            this.setImageSlider(slider);
        }
        this.setarSlider();
    },
    setImageSlider(slider) {
      this.productDetailSliders.push(Flickity.data(slider));
    },
    setarSlider() {
        this.arSlider = Flickity.data('.js-sliderar');
    },
    redrawSliders() {
      this.productDetailSliders.forEach((oSlider) => {
        oSlider.resize();
      });
    },
    selectConfigurationOption(level, refNr, eanNumber, index) {
      this.showStepIndicator = false;
      const currentErpOptionsIndex = this.erpOptions.length;

      this.erpOptions.push({ level, refNr, eanNumber });


      // Set the selected to true on the option the user clicked on
      Vue.set(this.configurator.currentChoicesList[index], 'selected', true);

      // Push the total ChoicesList to currentSelection array,
      // so we can use it to show the previous choices the user made
      this.currentSelection.push({
        name: this.configurator.currentChoicesOptionGroupName,
        level: this.configurator.currentChoicesLevel,
        groupNameIndex: this.currentChoiceStep,
        showIndex: this.configurator.showIndex,
        index: currentErpOptionsIndex,
        options: this.configurator.currentChoicesList,
      });

      if (!this.initializedDraggable) {
        Vue.nextTick(() => {
          draggable.initialize();
          this.initializedDraggable = true;
        });
      }

      Vue.nextTick(() => {
        draggable.checkDragScrollPos(draggable.oDraggableObjs[0], draggable.oDraggableObjs[0].nextElementSibling, draggable.oDraggableObjs[0].previousElementSibling);
      });

      this.previousChoicesGroupName = this.configurator.currentChoicesOptionGroupName;

      this.selectionIndex += 1;
      this.loadConfiguratorOptions();
    },
    resetConfigurationOption(level, refNr, eanNumber, index, levelIndex) {
      this.showStepIndicator = false;
      let currentSelectionIndex;
      let erpOptionsIndex;
      this.currentSelection.some((entry, i) => {
        if (entry.index === levelIndex) {
          currentSelectionIndex = i;
          return true;
        }
        return false;
      });

      this.erpOptions.some((entry, i) => {
        if (entry.index === levelIndex) {
          erpOptionsIndex = i;
          return true;
        }
        return false;
      });

      this.currentSelection[currentSelectionIndex].options.forEach((option) => {
        if (option.selected) {
          option.selected = false;
        }
      });

      Vue.set(this.currentSelection[currentSelectionIndex].options[index], 'selected', true);
      const oResetSelection = this.currentSelection[currentSelectionIndex];

      if (this.currentSelection[this.currentSelection.length - 1].level !== this.currentSelection[currentSelectionIndex].level) {
        if (typeof this.currentSelection[currentSelectionIndex - 1] !== 'undefined') {
          if (this.currentSelection[currentSelectionIndex - 1].name === this.currentSelection[currentSelectionIndex].name) {
            this.currentChoiceStep = this.currentSelection[currentSelectionIndex - 1].groupNameIndex + 1;
          } else if (this.currentSelection[currentSelectionIndex - 1].name !== this.currentSelection[currentSelectionIndex].name) {
            this.currentChoiceStep = 1;
          } else if (this.currentSelection[this.currentSelection.length - 1].name === this.currentSelection[currentSelectionIndex].name) {
            this.currentChoiceStep = currentSelectionIndex - (this.groupNameIndex + 1);
          }
        } else {
          this.currentChoiceStep = 1;
        }
      } else if ((this.currentSelection.length - 1) === currentSelectionIndex) {
        this.currentChoiceStep = this.currentSelection[currentSelectionIndex].groupNameIndex;
      } else if (typeof this.currentSelection[currentSelectionIndex - 1] !== 'undefined' && this.currentSelection[currentSelectionIndex - 1].name === this.currentSelection[currentSelectionIndex].name) {
        this.currentChoiceStep = this.currentSelection[currentSelectionIndex - 1].groupNameIndex + 1;
      } else {
        this.currentChoiceStep = 1;
      }

      this.erpOptions.length = erpOptionsIndex;
      this.previousChoicesGroupName = this.currentSelection[currentSelectionIndex].name;

      this.currentSelection.length = currentSelectionIndex;
      this.configurator.currentChoicesLevel = level;

      this.erpOptions.push({ level, refNr, eanNumber });
      this.currentSelection.push({
        name: oResetSelection.name,
        level: this.configurator.currentChoicesLevel,
        groupNameIndex: this.currentChoiceStep,
        index: levelIndex,
        showIndex: oResetSelection.showIndex,
        options: oResetSelection.options,
      });
      this.selectionIndex = this.currentSelection.length + 1;

      Vue.nextTick(() => {
        draggable.checkDragScrollPos(draggable.oDraggableObjs[0], draggable.oDraggableObjs[0].nextElementSibling, draggable.oDraggableObjs[0].previousElementSibling);
      });

      this.loadConfiguratorOptions();
    },
    loadConfiguratorOptions() {
        if (this.configuratorSettings.container !== null) {

            Vue.nextTick(() => {
                this.isLoading = true;

                fetch(`${this.configuratorSettings.url
                        }?width=${encodeURIComponent(this.configuratorSettings.width)
                        }&height=${encodeURIComponent(this.configuratorSettings.height)
                        }&ecotax=${encodeURIComponent(this.configuratorSettings.ecotax)
                        }&assemblycost=${encodeURIComponent(this.configuratorSettings.assemblyCost)
                        }&articlecode=${encodeURIComponent(this.configuratorSettings.articleCode)
                        }&collection=${encodeURIComponent(this.configuratorSettings.collection)
                        }&code=${encodeURIComponent(this.configuratorSettings.code)}`,
                        {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                                "Accept-Language": document.documentElement.lang,
                                "X-Requested-With": "XMLHttpRequest"

                            },
                            body: JSON.stringify(this.erpOptions),
                            credentials: 'same-origin',
                        })
                    .then(response => {

                        if (response.ok || response.status === 400) {
                            return response.json();
                        }
                        throw Error(response.statusText)
                    })
                    .then((response) => {

                        if (typeof response.message !== 'undefined') {

                            this.isLoading = false;
                            this.errorText = response.message;

                        } else {

                            this.isLoading = false;
                            this.configurator = response;
                            this.erpOptions = [];

                            if (this.configurator.currentConfigurationList) {
                                this.configurator.currentConfigurationList.forEach((config, i) => {
                                    this.erpOptions.push({
                                        level: config.level,
                                        refNr: config.refNr,
                                        eanNumber: config.eanNumber,
                                        index: i,
                                    });
                                });
                            }

                            if (this.previousChoicesGroupName === this.configurator.currentChoicesOptionGroupName) {
                                this.currentChoiceStep += 1;
                            } else {
                                this.currentChoiceStep = 1;
                            }

                            // Add 'showIndex' property to the currentChoicesList object to keep track of how many items should be showed
                            if (this.configurator.currentChoicesList.length >
                                this.configuratorSettings.showOptionSize) {
                                Vue.set(this.configurator, 'showIndex', 1);
                            }

                            if (this.first) {
                                this.first = false;
                            }

                            Vue.nextTick(() => {
                                fSliders();
                                fTooltip();
                                this.observeStepPosition();

                                if (this.configurator.completed) {
                                    this.showStepIndicator = false;

                                    Vue.nextTick(() => {
                                        initModals();
                                    });
                                }
                            });

                        }
                    }).catch(error => {
                        this.isLoading = false;
                        this.errorText = error;
                    });

            });
        }
    },
    toggleStepIndicator(entries) {
      entries.forEach((entry) => {
        if (entry.isIntersecting || this.configurator.completed) {
          this.showStepIndicator = false;
        } else {
          this.showStepIndicator = true;
        }
      });
    },
    showMoreOptions(c) {
      c.showIndex += 1;

      Vue.nextTick(() => {
        if (window.matchMedia(`(max-width: ${website.mobileBreakpoint}px)`).matches) {
          this.redrawSliders();
        }
      });
    },
    observeStepPosition() {
      const observeTargets = document.getElementsByClassName('configurator__config__group--current');
      IntersectionObserver.prototype.POLL_INTERVAL = 100;

      const observerOptions = {
        rootMargin: '0px',
        treshold: 0.5,
      };

      const observer = new IntersectionObserver(this.toggleStepIndicator, observerOptions);

      for (let i = 0; i < observeTargets.length; i += 1) {
        observer.observe(observeTargets[i]);
      }

      this.observerLoaded = true;
    },
    scrollToCurrentStep() {
      const oCurrentStep = document.querySelector('.configurator__config__group--current');
      scrollIt(oCurrentStep, 200, 'linear', 96);
    },
    historyBack() {
      window.history.back();
    },

    ModelViewerFullScreen(modelViewerId, buttonIconId, resize) {

        var fullHeight = window.innerHeight + "px";

        const modelviewerid = document.getElementById(modelViewerId);

        if (modelviewerid &&
            ((modelviewerid.style.height === "100%" && !resize) ||
            (modelviewerid.style.height !== "100%" && resize))) {

            this.zoomButtonPressed = true;

            const useElem = document.querySelector(buttonIconId);

            document.body.style.overflow = "hidden";

            if (modelViewerId !== 'dimensionsviewer') {
                useElem.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', '#zoomout');

                const elements = document.getElementsByClassName('productdetail__slider__main');
                const el = elements[0];
                el.style.width = "100vw";
                el.style.height = fullHeight;
                el.style.position = "fixed";
                el.style.backgroundColor = "#ffffff"; // this.backgroundColor; //"#f8f8f8";
                el.style.top = "0";
                el.style.left = "0";
                el.style.zIndex = "50";

                const elements2 = el.querySelector('.flickity-page-dots');
                if (elements2) {
                    const el2 = elements2;
                    el2.style.display = "none";
                }
                const elements3 = el.querySelector('.flickity-viewport');
                if (elements3) {
                    const el3 = elements3;
                    el3.style.minHeight = fullHeight;
                }

            } else {
                useElem.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', '#zoomout');

                const elements = document.getElementsByClassName('dimension-Viewer');
                const el = elements[0];
                el.style.width = "100vw";
                el.style.height = fullHeight;
                el.style.position = "fixed";
                el.style.backgroundColor = "#ffffff";
                el.style.top = "0";
                el.style.left = "0";
                el.style.zIndex = "50";
            }

            modelviewerid.style.height = fullHeight; // 100%
        }

    },

    ModelViewerNormalScreen(modelViewerId, buttonIconId) {

        const modelviewerid = document.getElementById(modelViewerId);

        this.zoomButtonPressed = true;

        const useElem = document.querySelector(buttonIconId);

        document.body.style.overflow = "";

        if (modelViewerId !== 'dimensionsviewer') {
            useElem.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', '#3drotate');

            const elements = document.getElementsByClassName('productdetail__slider__main');
            const el = elements[0];
            el.style.width = "";
            el.style.height = "";
            el.style.position = "";
            el.style.backgroundColor = "";
            el.style.top = "";
            el.style.left = "";
            el.style.zIndex = "";

            const elements2 = el.querySelector('.flickity-page-dots');
            if (elements2) {
                const el2 = elements2;
                el2.style.display = "";
            }

            const elements3 = el.querySelector('.flickity-viewport');
            if (elements3) {
                const el3 = elements3;
                el3.style.minHeight = "";
            }

        } else {
            useElem.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', '#zoomin');

            const elements = document.getElementsByClassName('dimension-Viewer');
            const el = elements[0];
            el.style.width = "";
            el.style.height = "";
            el.style.position = "";
            el.style.backgroundColor = "";
            el.style.top = "";
            el.style.left = "";
            el.style.zIndex = "";
        }

        modelviewerid.style.height = "100%"; // 100%

    }

  },
});
